// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"4a509b56","197":"93649315","207":"69a8ccd0","404":"c77a2db2","535":"a1ed588c","652":"387798de","694":"2ba0a89e","725":"388d2125","837":"49cd5f6a"}[chunkId] + ".chunk.js";
};